import React from 'react';
import { Provider } from 'react-redux';
import OidcWrapper from './src/components/OidcWrapper';
import userManager from './src/util/usermanager';

import createStore from './src/store';

export default ({ element }) => {
  const store = createStore();
  return (
    <Provider store={store}>
      <OidcWrapper store={store} userManager={userManager}>
        {element}
      </OidcWrapper>
    </Provider>
  );
};
